<template>
  <div>
    <b-container fluid>
      <!-- User Interface controls -->

      <b-row class="mt-5 justify-content-center">
        <b-col cols="6" md="6" class="my-1">
          <card>
            <div>
              <h1 class="text-center">Add Event</h1>
              <b-alert :show="showError" variant="danger">{{
                messageError
              }}</b-alert>
              <b-form @submit="onSubmit">
                <b-form-group
                  id="input-group-1"
                  label=" Event Name:"
                  label-for="input-1"
                >
                  <b-form-input
                    id="Event"
                    v-model="form.name"
                    type="text"
                    required
                    placeholder="Event name ex: BANSOS KEMENAG 2021"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  id="input-group-1"
                  label=" end date:"
                  label-for="input-1"
                >
                  <b-form-datepicker
                    id="example-datepicker"
                    v-model="form.end_time"
                    class="mb-2"
                  ></b-form-datepicker>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label=" total recipient:"
                  label-for="input-1"
                >
                  <b-form-input
                    id="Total"
                    v-model="form.total"
                    type="text"
                    required
                    placeholder="Total Recepient for this event,example:20"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  id="input-group-1"
                  label=" Criteria:"
                  label-for="input-1"
                >
                  <card>
                    <div v-for="(data, index) in arr_criteria" :key="index">
                      <b-form-group
                        class="mt-3"
                        id="input-group-1"
                        :label="'criteria ' + (index + 1) + ':'"
                        label-for="input-1"
                      ></b-form-group>
                      <b-form-input
                        id="Event"
                        v-model="arr_criteria[index].name"
                        type="text"
                        required
                        placeholder="criteria name"
                      ></b-form-input>
                      <b-form-input
                        id="Event"
                        v-model="arr_criteria[index].point"
                        class="mt-2"
                        type="text"
                        required
                        placeholder="point , ex:20 , max : all combination is 100"
                      ></b-form-input>
                      <b-form-select
                        v-model="arr_criteria[index].type"
                        :options="options_data"
                        size="l"
                        class="mt-2"
                      ></b-form-select>
                      <div
                        v-if="index != 0"
                        class="row mt-2 mb-5 justify-content-center"
                      >
                        <button
                          class="btn btn-icon btn-danger btn-outline mr-4"
                          @click="RemoveCriteria(index)"
                        >
                          <i class="nc-icon nc-simple-remove"></i>
                        </button>
                      </div>
                    </div>
                    <div class="row justify-content-center">
                      <div class="col-4">
                        <b-button
                          class="mr-1"
                          variant="primary"
                          @click="AddCriteria()"
                          >add criteria</b-button
                        >
                      </div>
                    </div>
                  </card>
                </b-form-group>

                <b-row class="justify-content-center">
                  <b-col class="text-center">
                    <b-col class="text-center">
                      <div v-if="!isLoading">
                        <b-button
                          class="mr-1"
                          type="reset"
                          variant="danger"
                          @click="$router.go(-1)"
                          >cancel</b-button
                        >
                        <b-button type="submit" variant="primary"
                          >Submit</b-button
                        >
                      </div>
                      <div v-if="isLoading">
                        <b-button disabled variant="primary"
                          >loading...</b-button
                        >
                      </div>
                    </b-col>
                  </b-col>
                </b-row>
              </b-form>
            </div>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Event from "@/api/EventApi";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import Floor from "@/api/FloorApi";
import Category from "@/api/CategoryApi";

export default {
  components: {
    VueUploadMultipleImage,
  },
  data() {
    return {
      options_floor: [{ value: null, text: "Please select an floor" }],
      options_category: [{ value: null, text: "Please select an floor" }],
      selected: null,
      arr_criteria: [
        {
          name: "input criteria name ex: Gaji",
          point: 100,
          type: null,
        },
      ],
      options_data: [
        { value: null, text: "Please select type", disabled: true },
        { value: "up", text: "Upper is Better" },
        { value: "down", text: "Lower is Better" },
      ],
      images: [],
      allImage: [],
      angka: 2,
      form: {
        name: "",
        content: null,
        start_date: null,
        end_time: null,
      },
      isLoading: false,
      options: [],
      show: true,
      messageError: "",
      showError: false,
    };
  },
  methods: {
    async uploadImageSuccess(formData, index, fileList) {
      let imgdata = new FormData();

      if (fileList.length < 5) {
        for (var pair of formData.entries()) {
          imgdata.append(pair[0], pair[1]);
          this.allImage.push(pair[1]);
        }
      }
    },
    RemoveCriteria(index) {
      this.arr_criteria.splice(index, 1);
    },
    AddCriteria() {
      this.arr_criteria.push({
        name: "input criteria name ex: Gaji",
        point: 0,
        type: null,
      });
    },
    beforeRemove(index, done, fileList) {
      console.log("index", index, fileList);

      var r = confirm("remove image");
      if (r == true) {
        done();
      } else {
        console.log("x");
      }
      if (fileList.length === 0) {
        this.allImage = null;
      }
    },
    editImage(formData, index, fileList) {
      for (var pair of formData.entries()) {
        imgdata.append(pair[0], pair[1]);
        this.allImage.push(pair[1]);
      }
    },
    async onSubmit(evt) {
      evt.preventDefault();

      this.isLoading = true;
      let data = this.form;
      data["criteria"] = this.arr_criteria;
      try {
        let res = await Event.Add(data);
        if (res.data.success) {
          this.success = true;
          this.$notify({
            message: "success",
            icon: "fa fa-check-circle",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
          this.$router.push({
            path: "/admin/Event",
          });
          this.isLoading = false;
        } else {
          this.isLoading = false;
          this.showError = true;
          this.messageError = res.data.message;
          this.$notify({
            message: res.data.message,
            icon: "fa fa-times-circle",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        }
      } catch (err) {
        this.isLoading = false;
        console.log(err);
      }
    },
  },
  async created() {
    let res_floor = await Floor.GetActive();
    let res_category = await Category.GetActive();
    let options_floor = [
      { value: null, text: "Please select an floor", disabled: true },
    ];
    let options_category = [
      { value: null, text: "Please select an category", disabled: true },
    ];

    res_floor.data.data.map((data) => {
      data = {
        value: data._id,
        text: `${data.name}`,
      };
      options_floor.push(data);
    });

    res_category.data.data.map((data) => {
      data = {
        value: data._id,
        text: `${data.name}`,
      };
      options_category.push(data);
    });

    this.options_floor = options_floor;

    this.options_category = options_category;

    // console.log(vendor_data[0]._id);
    // this.items = res.data.data;
  },
};
</script>